"use client";

import FinanceeMatchMinute from "@/components/FinanceeMatchMinute";
import starIcon from "@/assets/images/star.svg";
import starFeaturedIcon from "@/assets/images/star-featured.svg";
import { useMatchFavorite } from "@/hooks/useMatchFavorite";

export default function MatchTime({
  match,
  isLive,
  formattedThu,
  formattedDate,
  formattedGio,
  currentHomeScore,
  currentAwayScore,
  liveScore,
  statusNum,
  matchTime,
  halfStartTime,
  fontBody = "text-[13px]",
  borderColorClass,
  fullWidth = false,
}) {
  const { isFavorite, toggleFavorite } = useMatchFavorite(match);
  const widthClass = fullWidth ? "w-full" : "w-[10%] min-w-[34px]";
  const alignClass = fullWidth ? "items-start" : (isLive ? "items-center" : "items-end");
  const textAlignClass = fullWidth ? "text-left" : "text-right pr-[20%]";
  const paddingClass = fullWidth ? "pl-2.5 pb-1 pt-0.5" : "py-1";
  return (
    <div className={`kbv-ktm-border flex flex-row items-stretch flex-wrap ${widthClass} ${paddingClass} ${fullWidth ? "" : "border-r"} border-b-0 transition-colors group-hover:border-r-[var(--theme-foreground)] ${borderColorClass || ""}`}>
      <div className="flex items-start shrink-0 px-2.5">
        <button
          type="button"
          onClick={toggleFavorite}
          className="p-0 border-0 bg-transparent cursor-pointer inline-flex items-center justify-center focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--theme-foreground)] rounded"
          aria-label={isFavorite ? "Bỏ yêu thích trận đấu" : "Yêu thích trận đấu"}
        >
          <img src={isFavorite ? starFeaturedIcon : starIcon} alt="" className="w-[23px] h-[22px]" aria-hidden />
        </button>
      </div>
      <div className={`flex flex-col justify-start flex-wrap min-w-0 flex-1 ${alignClass}`}>
      {isLive ? (
        <FinanceeMatchMinute
          liveScore={liveScore}
          status={statusNum}
          matchTime={matchTime}
          halfStartTime={halfStartTime}
          className="kbv-ktm-time-live"
          currentHomeScore={currentHomeScore}
          currentAwayScore={currentAwayScore}
          fontBody={fontBody}
        />
      ) : (
        <div className={`flex ${fullWidth ? "flex-row items-center gap-1.5 flex-wrap" : "flex-col items-center"} min-w-0 w-full ${textAlignClass}`}>
          <div className={`${fontBody} font-bold text-[var(--theme-text)]`}>
            {formattedDate}
          </div>
          <div className={`kbv-ktm-time-value ${fontBody} font-bold`}>
            {formattedGio}
          </div>
        </div>
      )}
      </div>
    </div>
  );
}
